<div class="input-toggle" [class.input-toggle-disabled]="control?.disabled||disabled">
  <span>
    <label style="text-transform: uppercase" class="app-label" (click)="toggle($event)" [class.disabled]="control?.disabled||disabled"
      ><ng-content></ng-content
    ></label>
    <i
      style="padding-left: 5px; padding-bottom: 10px"
      tooltipPosition="top"
      pTooltip="{{ tooltip }}"
      *ngIf="tooltip && useIconToolTip"
      class="fa-solid fa-circle-question text-link-color"
    ></i>
  </span>
  <label
    class="toggle-switch"
    tooltipPosition="top"
    pTooltip="{{ tooltip }}"
    [tooltipOptions]="{ disabled: !tooltip || useIconToolTip }"
    [class.disabled]="control?.disabled||disabled"
    >
    <input
      [disabled]="control?.disabled||disabled"
      style="cursor: pointer"
      type="checkbox"
      [formControl]="control"
      (click)="toggle($event)"
    />
    <span class="slider" (click)="toggle($event)"></span>
    <span class="toggle-text on-text text-link-color" *ngIf="control?.value" (click)="toggle($event)"
      >{{'on'|translation}}</span
    >
    <span class="toggle-text off-text" *ngIf="!control?.value" (click)="toggle($event)">{{'off'|translation}}</span>
  </label>
</div>
